<div class="w-full flex flex-col gap-y-2">
    <div class="flex flex-row items-center gap-x-4 w-full pt-2">
        <h2 class="text-sm font-semibold text-primary flex-nowrap min-w-fit">Placements</h2>
        <div class="border-b border-gray-200 dark:border-gray-800 w-full"></div>
        <button (click)="expanded.set(!expanded())" type="button" class="fab-button-secondary-small text-secondary">
            @if (expanded()) {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m18 15-6-6-6 6" />
            </svg>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m6 9 6 6 6-6" />
            </svg>
            }
        </button>
    </div>

    @if (expanded()) {
    <article class="create-ad-group-card relative isolate flex flex-row gap-8 items-start w-full">
        <!-- TikTok Logo Section -->
        <div class="shrink-0 flex items-center justify-center p-4 rounded-md bg-zinc-100 dark:bg-zinc-800">
            <img src="../../../../../assets/social-icon/tik-tok-transparent.svg" alt="TikTok Logo"
                class="size-10 object-contain">
        </div>
        <!-- TikTok Logo Section - END -->

        <!-- Toggles Section -->
        <div class="flex-1 flex flex-col gap-y-4 divide-y divide-gray-200 dark:divide-zinc-700">
            <div class="flex items-center justify-between">
                <span class="flex grow flex-col">
                    <label id="comments-allow-label" class="text-sm/6 font-medium text-gray-900 dark:text-white">Allow User Comments</label>
                    <span id="comments-allow-description" class="text-sm text-gray-500 dark:text-gray-400">We recommend keeping user comments on to help your ads achieve more impressions and conversions. You can hide, pin, and reply to comments using our comment management tools.</span>
                </span>
                <div
                    class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-primary transition-colors duration-200 ease-in-out has-checked:bg-primary has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-primary dark:has-checked:bg-primary">
                    <span
                        class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"></span>
                    <input id="comments-allow-toggle" type="checkbox" name="commentsAllowed"
                        aria-labelledby="comments-allow-label"
                        aria-describedby="comments-allow-description"
                        [formControl]="commentsAllowedControl"
                        class="absolute inset-0 size-full appearance-none focus:outline-hidden" />
                </div>
            </div>


            <div class="flex items-center justify-between">
                <span class="flex grow flex-col">
                    <label id="video-download-label" class="text-sm/6 font-medium text-gray-900 dark:text-white">Allow Video Download</label>
                    <span id="video-download-description" class="text-sm text-gray-500 dark:text-gray-400">Let your audience download your videos. (Regional restrictions may apply)</span>
                </span>
                <div
                    class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-primary transition-colors duration-200 ease-in-out has-checked:bg-primary has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-primary dark:has-checked:bg-primary">
                    <span
                        class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"></span>
                    <input id="video-download-toggle" type="checkbox" name="videoDownloadAllowed"
                        aria-labelledby="video-download-label"
                        aria-describedby="video-download-description"
                        [formControl]="videoDownloadAllowedControl"
                        class="absolute inset-0 size-full appearance-none focus:outline-hidden" />
                </div>
            </div>


            <div class="flex items-center justify-between">
                <span class="flex grow flex-col">
                    <label id="video-sharing-label" class="text-sm/6 font-medium text-gray-900 dark:text-white">Allow Video Sharing</label>
                    <span id="video-sharing-description" class="text-sm text-gray-500 dark:text-gray-400">People will be able to share your video on TikTok, as well as through direct messages, SMS, email, Instagram, and more.</span>
                </span>
                <div
                    class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-primary transition-colors duration-200 ease-in-out has-checked:bg-primary has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-primary dark:has-checked:bg-primary">
                    <span
                        class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"></span>
                    <input id="video-sharing-toggle" type="checkbox" name="videoSharingAllowed"
                        aria-labelledby="video-sharing-label"
                        aria-describedby="video-sharing-description"
                        [formControl]="videoSharingAllowedControl"
                        class="absolute inset-0 size-full appearance-none focus:outline-hidden" />
                </div>
            </div>

        </div>
        <!-- Toggles Section - END -->
    </article>
    }
</div>